<template>
  <div class="option-list">
    <div class="mb-2 d-flex justify-content-between">
      <span class="small text-muted">
        {{ group.max_selections === 1 ? 'Single selection' : 'Multiple selections' }}
      </span>
      <span class="badge badge-primary">
        Min: {{ group.min_selections || 0 }} / Max: {{ group.max_selections || 'All' }}
      </span>
    </div>

    <div 
      v-for="(opt, i) in group.options" 
      :key="'opt-' + i" 
      class="option-item d-flex align-items-center mb-2 p-2 rounded bg-white border"
    >
      <CIcon name="cil-check-circle" class="mr-2 text-success" />
      <span class="flex-grow-1">{{ opt.name }}</span>
      <span 
        v-if="opt.price_adjustment && parseFloat(opt.price_adjustment) !== 0" 
        class="ml-3 text-info font-weight-bold"
      >
        {{ parseFloat(opt.price_adjustment) > 0 ? '+' : '' }}{{ parseFloat(opt.price_adjustment) | toCurrency }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionsList',
  props: {
    group: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.option-list {
  padding: 0 0.5rem;
}
</style>
